import type { Reducer } from 'redux';

import type { DeferredFeedsClearAction } from '../../domains/deferredFeeds/actions.types';
import type { FeedLoadDeferredFulfillAction } from '../../domains/feedLoad/actions.types';
import type { FeedThreadUpdateTimeInfo } from '../types';

import type { DeferredFeeds } from './types';

export type DeferredFeedsAction = FeedLoadDeferredFulfillAction | DeferredFeedsClearAction;

const initialState: DeferredFeeds = {
  current: undefined,
  latest: undefined,
};

const reducer: Reducer<DeferredFeeds, DeferredFeedsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_DEFERRED_FULFILL':
      return {
        current: {
          id: action.payload.id,
          lastMessageId: action.payload.currentFeedLastMessageInfo?.lastMessageId,
          lastMessageAt: action.payload.currentFeedLastMessageInfo?.lastMessageAt,
          topThreadsIds: action.payload.currentFeedThreadsUpdateTimes
            ? action.payload.currentFeedThreadsUpdateTimes.map((update: FeedThreadUpdateTimeInfo) => update.threadId)
            : undefined,
          topThreadsUpdateTimes: action.payload.currentFeedThreadsUpdateTimes
            ? action.payload.currentFeedThreadsUpdateTimes.map((update: FeedThreadUpdateTimeInfo) => update.updatedAt)
            : undefined,
        },
        latest: {
          id: action.payload.id,
          lastMessageId: action.payload.latestFeedLastMessageInfo?.lastMessageId,
          lastMessageAt: action.payload.latestFeedLastMessageInfo?.lastMessageAt,
          topThreadsIds: action.payload.latestFeedThreadsUpdateTimes
            ? action.payload.latestFeedThreadsUpdateTimes.map((update) => update.threadId)
            : undefined,
          topThreadsUpdateTimes: action.payload.latestFeedThreadsUpdateTimes
            ? action.payload.latestFeedThreadsUpdateTimes.map((update) => update.updatedAt)
            : undefined,
        },
      };
    case 'DEFERRED_FEEDS.CLEAR':
      return initialState;
    default:
      return state;
  }
};

export default reducer;
